import request from "@/utils/request";

export function getShopList(params) {
  return request({
    url: "/userShop/page",
    method: "get",
    params
  });
}

export function getShopById(id) {
  return request({
    url: `/userShop/getById/${id}`,
    method: "get"
  });
}
